import React from "react";

export default function PillProduccion() {
  return <div className="pill produccion">Producción</div>;
}
